const meetingPlatforms: { label: string; hosts: string[] }[] = [
  { label: 'Zoom', hosts: ['zoom.us', 'zoomgov.com'] },
  {
    label: 'MS Teams',
    hosts: ['teams.microsoft.com', 'teams.live.com', 'teams.microsoft.us'],
  },
  { label: 'Google Meet', hosts: ['meet.google.com'] },
  { label: 'Webex', hosts: ['webex.com'] },
];

export const getMeetingPlatformLabel = (meetingUrl: string): string => {
  let hostname: string;
  try {
    hostname = new URL(meetingUrl).hostname.toLowerCase();
  } catch {
    return 'Meeting link';
  }

  const platform = meetingPlatforms.find(({ hosts }) =>
    hosts.some((host) => hostname === host || hostname.endsWith(`.${host}`)),
  );
  return platform?.label ?? 'Meeting link';
};
